import { createFileRoute } from "@tanstack/react-router";

import { ShareLanding, shareLandingHead } from "../components/ShareLanding";
import { documentHeaders } from "../lib/seo";

/**
 * `/r/<code>` — the web side of a referral link.
 *
 * On a phone with Fazly installed this page is never reached: iOS and Android
 * hand the URL to the app instead (that is what the association files in
 * `/.well-known` buy us). This is the fallback for everyone else, and what it
 * does and does not show is explained in `ShareLanding` — including the fact
 * that nothing in the app hands out one of these links yet.
 *
 * The path segment is `User.referralCode` — a short, human-typeable code minted
 * by `mintReferralCode()` in packages/api/src/routers/user.ts. This page does
 * not read it, resolve it or display it. It cannot: there is no referral router
 * to ask, and `user.register` takes `referredByCode` from the CLIENT, so the
 * only thing the code could do here is sit on screen next to no field to type
 * it into.
 *
 * Note which identifier this is, because the app has two and only one of them
 * may ever appear in a URL: `User.referralCode` is public by design;
 * `User.deviceId` is the recovery credential and publishing it is an
 * account-takeover bug (CLAUDE.md rule 8).
 */
export const Route = createFileRoute("/r/$code")({
  headers: documentHeaders,
  head: () => shareLandingHead("referral"),
  component: () => <ShareLanding kind="referral" />,
});
